import React from "react";
import { Button, CircularProgress } from "@mui/material";

const TertiaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      color="error"
      disabled={isLoading || disabled}
      disableElevation
      startIcon={isLoading ? undefined : startIcon}
      sx={{
        fontWeight: 600,
        borderRadius: "8px",
        textTransform: "none",
        height: "45px",
        backgroundColor: "#dc2626",
        color: "white",
        "&:hover": {
          backgroundColor: "#b91c1c",
        },
        ...sx,
      }}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default TertiaryButton;
